function belMarketingSuccess()
{
    UpdateMarketingTypeDescription();
    UpdateCountAndCriteria();
}